export default {
    noPaper: "暫無試題",
    arrangementTime: "安排時間",
    tabEnd: "結束",
    tabVideo: "視頻",
    tabPaper: "試題",
    videoStatus: {
        notStart: "未開始",
        connect: "可連接",
        interviewing: "視頻中",
        hangup: "已掛斷",
        ended: "已結束",
        checkIn: "已登入",
        online: "線上",
        offline: "離線",
    },
    fraud: "舞弊",
    fraudCancel: "取消舞弊標記",
    absent: "缺考",
    absentCancel: "取消缺考標記",
    groupName: "所屬組",
    groupNumber: "編號",
    number: "{number}號",
    view: "查看",
    noDataMsg: "暫無評分表",
    yes: "是",
    placeholder: {
        reason: "請輸入修改原因",
        old_score: "請輸入原評分",
        new_score: "請輸入修改後的評分",
    },
    fraudConfirmMsg: "標記舞弊後,候選人將不能被評分,成績作廢,確定標記？",
    fraudCancelMsg: "確認取消該候選人的舞弊標記？",
    absentConfirmMsg: "標記缺考後,候選人將不能被評分,成績作廢,確定標記？",
    absentCancelMsg: "確認取消該候選人的缺考標記？",
    signOutConfirmMsg: "確定退出面試評分系統？",
    signOutCancelMsg: "取消退出",
    interviewingAlertMsg: "當前選手暫未打分",
    scoreMsg: ["當前候選人的分數是", "結果", "您確定提交嗎？"],
    scoreAlertMsg: "評分項“{msg}”未判分,請在所有評分項判分後提交面試結果",
    error307: "您已被管理員結束打分,點擊確定後,將跳轉到首頁",
    error401: "登入過期,請重新登入",
    successMsg: {
        processing: "修改成績申請中,請耐心等待",
        confirmed: "管理員已同意修改成績申請",
        unconfirmed: "管理員已拒絕修改成績申請",
        default: "出了一些問題",
    },
    applicationNotify: "申請狀態提示",
    showHistoryNoData: "此候選人暫無歷史成績",
    videoOpreateStartAlert: "面試時間未到,請稍後…",
    videoOpreateEndAlert: "面試已結束,如有需要請聯系管理員",
    btnContent: {
        waiting: "開始評分",
        interviewing: "完成",
        complete: "修改成績",
        processing: "查看申請狀態",
        confirmed: "修改成績",
        unconfirmed: "修改成績",
    },
    period: "。",
};
